import React from 'react';
import { Route, Redirect } from 'react-router-dom';

function FinanceStaffRoute({component: Component, ...restProps}) {
    const financeStaff = localStorage.getItem('isFinanceStaff');

    return <Route
        {...restProps}
        render = {props => {
            return financeStaff ? <Component {...props} /> : <Redirect to={{pathname: '/login'}} />
        }}
    />
}

export default FinanceStaffRoute;